import { changeFilteredInfo } from "@/utils/data/tableCol/tableUtils";
export const bzStatisticsByProjectStatusColumnsData = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '项目ID',
            dataIndex: 'projectId',
            key: 'projectId',
            width: 200,
            sorter: false,
            sortDirections: ["descend", "ascend", "descend"],
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                customRender: 'projectId'
            },
            filteredValue: filteredInfo.projectId || [],
        },
        {
            title: '销售姓名',
            dataIndex: 'salesName',
            key: 'salesName',
            width: 200,
            sorter: false,
            sortDirections: ["descend", "ascend", "descend"],
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                customRender: 'salesName'
            },
            filteredValue: filteredInfo.salesName || [],
        },
        {
            title: '客户列表',
            dataIndex: 'customerName',
            key: 'customerName',
            sorter: false,
            sortDirections: ["descend", "ascend", "descend"],
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                customRender: 'customerName'
            },
            filteredValue: filteredInfo.customerName || [],
        },
        {
            title: '项目状态',
            dataIndex: 'vitality',
            key: 'vitality',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"],
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                customRender: 'vitality'

            },
            filteredValue: filteredInfo.vitality || [],
        },
        {
            title: '分析数量',
            dataIndex: 'analyzeNum',
            key: 'analyzeNum',
            sorter: false,
            sortDirections: ["descend", "ascend", "descend"],
            scopedSlots: {
            },
            filteredValue: filteredInfo.analyzeNum || [],
        },
        {
            title: '客户新建分析数量',
            dataIndex: 'customerCreateNum',
            key: 'customerCreateNum',
            sorter: false,
            sortDirections: ["descend", "ascend", "descend"],
            scopedSlots: {
            },
            filteredValue: filteredInfo.customerCreateNum || [],
        },
    ]
}